
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { 
  AlertDialog, 
  AlertDialogAction, 
  AlertDialogCancel, 
  AlertDialogContent, 
  AlertDialogDescription, 
  AlertDialogFooter, 
  AlertDialogHeader, 
  AlertDialogTitle, 
  AlertDialogTrigger 
} from "@/components/ui/alert-dialog";
import { useLanguage } from "@/contexts/language";

interface DeleteButtonProps {
  onDelete: () => void;
}

const DeleteButton = ({ onDelete }: DeleteButtonProps) => {
  const [open, setOpen] = useState(false);
  const { language } = useLanguage();

  const getAlertTexts = () => {
    if (language === 'ja') {
      return {
        areYouSure: "本当によろしいですか？",
        description: "この日記エントリーは完全に削除されます。",
        cancel: "キャンセル",
        delete: "削除",
        buttonText: "削除"
      };
    } else if (language === 'es') {
      return {
        areYouSure: "¿Estás seguro?",
        description: "Esto eliminará permanentemente esta entrada del diario.",
        cancel: "Cancelar",
        delete: "Eliminar",
        buttonText: "Eliminar"
      };
    } else {
      return {
        areYouSure: "Are you sure?",
        description: "This will permanently delete this diary entry.",
        cancel: "Cancel",
        delete: "Delete",
        buttonText: "Delete"
      };
    }
  };

  const alertTexts = getAlertTexts();

  return (
    <AlertDialog open={open} onOpenChange={setOpen}>
      <AlertDialogTrigger asChild>
        <Button variant="outline" size="sm" className="text-xs">
          {alertTexts.buttonText}
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{alertTexts.areYouSure}</AlertDialogTitle>
          <AlertDialogDescription>
            {alertTexts.description}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>{alertTexts.cancel}</AlertDialogCancel>
          <AlertDialogAction onClick={onDelete}>{alertTexts.delete}</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default DeleteButton;
